export default __webpack_public_path__ + "static/tes-cube-sq-6799be076891b58ac2d127bd38c0f99d.jpg";